export const LOAD_TEMPLATE_CATEGORIES = 'LOAD_TEMPLATE_CATEGORIES'
export const LOAD_TEMPLATE_CATEGORIES_ERROR = 'LOAD_TEMPLATE_CATEGORIES_ERROR'
export const LOAD_TEMPLATE_CATEGORIES_SUCCESS = 'LOAD_TEMPLATE_CATEGORIES_SUCCESS'

export const SELECT_TEMPLATE_CATEGORY = 'SELECT_TEMPLATE_CATEGORY'
export const DESELECT_TEMPLATE_CATEGORY = 'DESELECT_TEMPLATE_CATEGORY'

export const SAVE_TEMPLATE_CATEGORY = 'SAVE_TEMPLATE_CATEGORY'
export const SAVE_TEMPLATE_CATEGORY_SUCCESS = 'SAVE_TEMPLATE_CATEGORY_SUCCESS'
export const SAVE_TEMPLATE_CATEGORY_ERROR = 'SAVE_TEMPLATE_CATEGORY_ERROR'

export const CREATE_TEMPLATE_CATEGORY = 'CREATE_TEMPLATE_CATEGORY'
export const CREATE_TEMPLATE_CATEGORY_ERROR = 'CREATE_TEMPLATE_CATEGORY_ERROR'
export const CREATE_TEMPLATE_CATEGORY_SUCCESS = 'CREATE_TEMPLATE_CATEGORY_SUCCESS'

export const UPDATE_TEMPLATE_CATEGORY = 'UPDATE_TEMPLATE_CATEGORY'
export const UPDATE_TEMPLATE_CATEGORY_ERROR = 'UPDATE_TEMPLATE_CATEGORY_ERROR'
export const UPDATE_TEMPLATE_CATEGORY_SUCCESS = 'UPDATE_TEMPLATE_CATEGORY_SUCCESS'

export const DELETE_TEMPLATE_CATEGORY = 'DELETE_TEMPLATE_CATEGORY'
export const DELETE_TEMPLATE_CATEGORY_ERROR = 'DELETE_TEMPLATE_CATEGORY_ERROR'
export const DELETE_TEMPLATE_CATEGORY_SUCCESS = 'DELETE_TEMPLATE_CATEGORY_SUCCESS'

export const LOAD_TEMPLATE_LIST = 'LOAD_TEMPLATE_LIST'
export const LOAD_TEMPLATE_LIST_ERROR = 'LOAD_TEMPLATE_LIST_ERROR'
export const LOAD_TEMPLATE_LIST_SUCCESS = 'LOAD_TEMPLATE_LIST_SUCCESS'

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'

export const SEARCH_TEMPLATE_LIST = 'SEARCH_TEMPLATE_LIST'
export const SEARCH_TEMPLATE_LIST_ERROR = 'SEARCH_TEMPLATE_LIST_ERROR'
export const SEARCH_TEMPLATE_LIST_SUCCESS = 'SEARCH_TEMPLATE_LIST_SUCCESS'
export const SEARCH_TEMPLATE_LIST_RESET = 'SEARCH_TEMPLATE_LIST_RESET'

export const SELECT_TEMPLATE = 'SELECT_TEMPLATE'
export const DESELECT_TEMPLATE = 'DESELECT_TEMPLATE'

export const CREATE_TEMPLATE = 'CREATE_TEMPLATE'
export const CREATE_TEMPLATE_ERROR = 'CREATE_TEMPLATE_ERROR'
export const CREATE_TEMPLATE_SUCCESS = 'CREATE_TEMPLATE_SUCCESS'

export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const UPDATE_TEMPLATE_ERROR = 'UPDATE_TEMPLATE_ERROR'
export const UPDATE_TEMPLATE_SUCCESS = 'UPDATE_TEMPLATE_SUCCESS'

export const UPLOAD_TEMPLATE_FILE = 'UPLOAD_TEMPLATE_FILE'
export const UPLOAD_TEMPLATE_FILE_ERROR = 'UPLOAD_TEMPLATE_FILE_ERROR'
export const UPLOAD_TEMPLATE_FILE_SUCCESS = 'UPLOAD_TEMPLATE_FILE_SUCCESS'

export const SAVE_TEMPLATE = 'SAVE_TEMPLATE'
export const SAVE_TEMPLATE_ERROR = 'SAVE_TEMPLATE_ERROR'
export const SAVE_TEMPLATE_SUCCESS = 'SAVE_TEMPLATE_SUCCESS'

export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const DELETE_TEMPLATE_ERROR = 'DELETE_TEMPLATE_ERROR'
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS'
